import { render, staticRenderFns } from "./BookingDetailShorex.vue?vue&type=template&id=492ffc99&scoped=true"
import script from "./BookingDetailShorex.vue?vue&type=script&lang=js"
export * from "./BookingDetailShorex.vue?vue&type=script&lang=js"
import style0 from "./BookingDetailShorex.vue?vue&type=style&index=0&id=492ffc99&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492ffc99",
  null
  
)

export default component.exports